import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id DF23FF47-4DD3-4CB3-9BEC-6EE986B0FA65
 * name page-first
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-first.svg
 * tags
 */
export const PageFirstIcon = createSvgIcon(<><path d="M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z" /></>, 'PageFirstIcon');
export default PageFirstIcon